export function ocultarTelefone(telefone: string): string {
  const telefoneLimpo = telefone.replace(/[()-]/g, '').replace(/\s/g, "");
  const codigoArea = telefoneLimpo.slice(0, 2);
  const prefixo = telefoneLimpo.slice(2, 5);
  const meio = telefoneLimpo.slice(5, 8);
  const sufixo = telefoneLimpo.slice(-3);

  const prefixoSufixoOculto = '****';
  const meioOculto = meio.replace(/\d/g, '*');

  return `(${codigoArea}) ${prefixo}${prefixoSufixoOculto}${meioOculto}${sufixo}`;
}